import { render, staticRenderFns } from "./videoCreation.vue?vue&type=template&id=538e7914&scoped=true"
import script from "./videoCreation.vue?vue&type=script&lang=js"
export * from "./videoCreation.vue?vue&type=script&lang=js"
import style0 from "./videoCreation.vue?vue&type=style&index=0&id=538e7914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e7914",
  null
  
)

export default component.exports